.iconContainer {
  display: flex;
  align-items: center;

  &.designDefault {
    background-color: var(--light-100);
    border-radius: 4px;
    padding: 1px;
  }

  &.pinterest {
    background-color: var(--light-100);
    border-radius: 20px;
  }

  &.ebay {
    background-color: var(--light-100);
    border-radius: 4px;
    padding: 0 2px;
  }
}

.isWhite {
  &.instagram,
  &.linkedIn,
  &.x,
  &.tikTok,
  &.google,
  &.amazon,
  &.squareSpace,
  &.etsy {
    path {
      fill: white;
    }
  }

  &.facebook {
    path:first-of-type {
      fill: white;
    }

    path:last-of-type {
      fill: transparent;
    }
  }

  &.shopify {
    path {
      fill: white;
    }

    path:last-of-type {
      fill: var(--selected-fill);
    }
  }

  &.youtube {
    path:first-of-type {
      fill: white;
    }

    path:last-of-type {
      fill: var(--selected-fill);
    }
  }
}
